import * as _ from 'lodash';
import nvSharedModelsModule from '../nv.shared.models.module';

angular.module(nvSharedModelsModule).factory('Note', function(NvBaseModel, PublicConfig, $http) {
  const PERMISSIONING_MODEL_NAME = 'NOTE';
  const relationToUserPath = 'createdBy.userId';

  let Note = NvBaseModel(
    // eslint-disable-line new-cap
    '/v1/notes/:id',
    { id: '@_id', schoolId: '@schoolId' },
    null,
    null,
    PERMISSIONING_MODEL_NAME,
    relationToUserPath,
  );

  Note.bulkCreate = (studentIds, note) => {
    const url = PublicConfig.NV_API_ORIGIN + '/v1/notes/bulk/create';
    const data = _.assign(note, { studentIds });
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/html',
      },
    };

    return $http.post(url, data, options);
  };

  // fields that the backend allows to be patched
  // notes have field level permissioning
  Note.FIELDS_THAT_CAN_BE_PATCHED = ['body', 'status', 'category', 'categoryOtherVal', 'attachments'];

  return Note;
});
